import { TnWarrantyList } from './views/TnWarrantyList';
import { MasterSheetEdit } from '../master-sheet-v2/views';

export default {
  edit: MasterSheetEdit,
  list: TnWarrantyList,
  name: 'tn-warranty-list',
  label: 'TN Warranty List',
  to: '/tn-warranty-list',
};

